import { call, put, select, takeLatest } from 'redux-saga/effects';
import { YieldOf } from 'types/utils';
import { sendedEmail, sendEmail, updatePassword, updatedPassword } from './actions';
import { logout } from '../api-auth/actions';
import getAPI from '../../api/iv-back';
import { isLoginExpiredSelector } from '../api-auth/selectors';
import { clearStateSlice } from '../clear-slice/actions';

type SendEmailPayload = ReturnType<typeof sendEmail>;
type UpdatePasswordPayload = ReturnType<typeof updatePassword>;

function* sendEmailSaga({ payload }: SendEmailPayload) {
  const { resetPassword } = getAPI();
  const response: YieldOf<typeof resetPassword> = yield call(resetPassword, payload);
  const { ok, problem, status } = response;
  if (status === 401 || status === 403) {
    yield put(logout());
  }
  if (ok) {
    yield put(sendedEmail(undefined));
  } else {
    const error = problem || 'unknown';
    yield put(sendedEmail(error));
  }
}

function* updatePasswordSaga({ meta, payload }: UpdatePasswordPayload) {
  const { updatePassword: updatedPasswordApi } = getAPI();
  const response: YieldOf<typeof updatedPasswordApi> = yield call(updatedPasswordApi, payload);
  const { ok, problem, status, data } = response;

  const isLoginExpired = select(isLoginExpiredSelector);
  if (!isLoginExpired && (status === 401 || status === 403)) {
    yield put(logout());
  }
  if (ok) {
    if (isLoginExpired) {
      yield put(clearStateSlice({ sliceReducer: 'APIAuth' }));
    }
    yield put(updatedPassword(undefined, undefined));
    if (meta.callback) yield call(meta.callback);
  } else {
    const error = problem || 'unknown';
    if (data && data?.message) {
      yield put(updatedPassword(error, data.message));
    } else {
      yield put(updatedPassword(error, undefined));
    }
  }
}

export default function* resetPasswordSaga() {
  yield takeLatest(sendEmail.type, sendEmailSaga);
  yield takeLatest(updatePassword.type, updatePasswordSaga);
}
